<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="alert alert-info" role="status">{{$t('alerts.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link
            :to="{ name: 'EXCMAgreementTypeList' }"
            class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMAgreementTypeForm
                    :handle-submit="onSendForm"
                    :handle-update-field="updateField"
                    :values="item"
                    :errors="violations" />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMAgreementTypeForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'

const { mapGetters, mapActions } = createNamespacedHelpers('excmagreementtype/create')

export default {
  components: {
    EXCMAgreementTypeForm
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMAgreementTypeCreate')
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'EXCMAgreementTypeUpdate', params: { id: created['@id'] } })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
